import { useState } from "react"
import PropTypes from "prop-types"
import FilterButton from "./FilterButton"
import FilterBadgeContent from "./FilterBadgeContent"
import { Select, Checkbox } from "components/ui"
import { isBlank } from "utils/helpers"

export const ASSIGNMENT_KIND = "assignment"

export const assignmentBadge = (selected, options) => {
  const type = options.find(o => o.id.toString() === selected.value.toString())

  return (
    <FilterBadgeContent
      label="Assignment"
      value={
        selected.extra && selected.extra.length > 0
          ? type.areas
              .filter(a => selected.extra.includes(a.id.toString()))
              .map(a => a.name)
              .join(", ")
          : `${type.name} (any area)`
      }
    />
  )
}

const AssignmentOptions = ({ onSubmit, options = [] }) => {
  const [value, setValue] = useState("")
  const [extra, setExtra] = useState([])

  const handleChange = e => {
    setValue(e.target.value)
    setExtra([])
  }

  const handleSelect = e => {
    if (e.target.checked) {
      setExtra([...extra, e.target.value])
    } else {
      setExtra(extra.filter(ex => ex !== e.target.value))
    }
  }

  const handleSubmit = () => {
    onSubmit({
      value,
      ...(!isBlank(extra) && { extra }),
      label: assignmentBadge({ value, extra }, options),
      kind: ASSIGNMENT_KIND
    })

    setValue("")
    setExtra([])
  }

  const type = options.find(o => o.id.toString() === value.toString())

  return (
    <>
      <Select
        name="assignment"
        value={value}
        onChange={handleChange}
        options={[
          { value: "", label: "Select an assignment" },
          ...options.map(option => ({
            value: option.id,
            label: option.name
          }))
        ]}
      />
      {type && type.areas.length > 0 && (
        <div className="py-2">
          <h5 className="m-0 label">Include</h5>
          {type &&
            type.areas.map(area => (
              <Checkbox
                key={area.id}
                name={`assignmentArea_${area.id}`}
                htmlFor={`assignmentArea_${area.id}`}
                text={area.name}
                value={area.id.toString()}
                checked={extra.includes(area.id.toString())}
                onSelect={handleSelect}
                labelClasses="mb-1 ws-n"
              />
            ))}
        </div>
      )}

      <FilterButton disabled={isBlank(value)} onSubmit={() => handleSubmit(type)} />
    </>
  )
}

AssignmentOptions.propTypes = {
  onSubmit: PropTypes.func,
  options: PropTypes.array
}

export default AssignmentOptions
